var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3749 10.5V7.5C15.3749 4.67157 15.3749 3.25736 14.4963 2.37868C13.6176 1.5 12.2034 1.5 9.37492 1.5H8.625C5.79662 1.5 4.38242 1.5 3.50375 2.37867C2.62506 3.25734 2.62505 4.67154 2.62503 7.49995L2.625 10.4999C2.62498 13.3284 2.62496 14.7426 3.50365 15.6213C4.38233 16.5 5.79655 16.5 8.625 16.5H9.37492C12.2034 16.5 13.6176 16.5 14.4963 15.6213C15.3749 14.7427 15.3749 13.3284 15.3749 10.5Z",
    stroke: "#141B34",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.25H12M6 9H12M6 12.75H9",
    stroke: "#141B34",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/Note.202b3d56f794a68cbe2149ef79c2ca04.svg";
export { ForwardRef as ReactComponent };